export function isTargetVariable(type?: string): boolean {
  if (type) {
    return ['SET_VARIABLE'].includes(type);
  }

  return false;
}
